<template>
  <!--main-->
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="sign__page">
          <div class="form">
            <ul class="form__ul">
              <li class="form__li m20">
                <div class="form__ttl">아이디<span class="required"> *</span></div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="text" :class="{'is-invalid': $v.params.userID.$error}" placeholder="아이디를 입력해주세요." v-model.trim="params.userID" maxlength="15">
                    </label>
                    <div class="hint on" v-show="$v.params.userID.$error">{{ valid.msg.userID }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li m20">
                <div class="form__ttl">비밀번호<span class="required"> *</span></div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="password" :class="{'is-invalid': $v.params.userPWD.$error}" placeholder="비밀번호를 입력해주세요." v-model="params.userPWD" maxlength="15">
                    </label>
                    <div class="hint on" v-show="$v.params.userPWD.$error">{{ valid.msg.userPWD }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li m20">
                <div class="form__ttl">비밀번호 확인<span class="required"> *</span></div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="password" :class="{'is-invalid': $v.params.userPWDConfirm.$error}" placeholder="비밀번호 확인을 입력해주세요." v-model="params.userPWDConfirm" maxlength="15">
                    </label>
                    <div class="hint on" v-show="$v.params.userPWDConfirm.$error">{{ valid.msg.userPWDConfirm }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li m20">
                <div class="form__ttl">회사명<span class="required"> *</span></div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="text" :class="{'is-invalid': $v.params.companyName.$error}" placeholder="회사명을 입력해주세요." v-model.trim="params.companyName">
                    </label>
                    <div class="hint on" v-show="$v.params.companyName.$error">{{ valid.msg.companyName }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li m20">
                <div class="nomore">
                  <div class="checkbox_line">
                    <label class="checkbox">
                      <input type="checkbox" v-model="noMoreInfo">
                      <span class="label underline"><span>추가 정보 입력 건너뛰기</span></span>
                    </label>
                  </div>
                </div>
              </li>
              <li class="form__li m20" v-show="!noMoreInfo">
                <div class="form__ttl">사업자 등록번호<span class="required"> *</span></div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="text" :class="{'is-invalid': $v.params.companyNumber.$error}" placeholder="사업자 등록번호를 입력해주세요." v-model.trim="params.companyNumber">
                    </label>
                    <div class="hint on" v-show="$v.params.companyNumber.$error">{{ valid.msg.companyNumber }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li m20" v-show="!noMoreInfo">
                <div class="form__ttl">팩스번호</div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="text" :class="{'is-invalid': $v.params.companyFax.$error}" placeholder="팩스번호를 입력해주세요." v-model.trim="params.companyFax">
                    </label>
                    <div class="hint on" v-show="$v.params.companyFax.$error">{{ valid.msg.companyFax }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li m20" v-show="!noMoreInfo">
<!--                <div class="form__ttl">소재지<span class="required"> *</span></div>-->
                <div class="form__ttl">소재지<span class="required"> *</span></div>
                <div class="form__in">
                  <div class="inline">
                    <label class="input">
                      <input type="text" v-model="params.companyAddress1" disabled>
                    </label>
                    <button class="btn type_02" @click="fnSearch">검색</button> <!--노란색 버튼은 type_02-->
                  </div>
                  <div class="inline">
                    <label class="input">
                      <input type="text" placeholder="상세주소를 입력해주세요." v-model="params.companyAddress2">
                    </label>
                  </div>
                </div>
              </li>
              <li class="form__li m20" v-if="!noMoreInfo">
                <div class="form__ttl">담당자(대표자) 명<span class="required"> *</span></div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="text" :class="{'is-invalid': $v.params.contactName.$error}" placeholder="담당자 이름을 입력해주세요." v-model.trim="params.contactName">
                    </label>
                    <div class="hint on" v-show="$v.params.contactName.$error">{{ valid.msg.contactName }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li m20" v-if="!noMoreInfo">
                <div class="form__ttl">담당자(대표자) E-Mail<span class="required"> *</span></div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="text" :class="{'is-invalid': $v.params.contactEmail.$error}" placeholder="담당자 E-Mail주소를 입력해주세요." v-model.trim="params.contactEmail">
                    </label>
                    <div class="hint on" v-show="$v.params.contactEmail.$error">{{ valid.msg.contactEmail }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li m20" v-if="!noMoreInfo">
                <div class="form__ttl">담당자(대표자) 연락처<span class="required"> *</span></div>
                <div class="form__in">
                  <div class="inline">
                    <label class="input">
                      <input type="number" placeholder="담당자 휴대폰 번호를 인증해주세요." v-model="params.contactPhone" @input="numberOnly(params.contactPhone, 'contactPhone')" maxlength="11">
                    </label>
                    <button class="btn type_02" @click="sendPhoneAuth">{{ sendPhoneAuthText }}</button> <!--노란색 버튼은 type_02-->
                  </div>
                  <div class="inline" v-show="isSendAuth">
                    <label class="input timer">
                      <input type="number" placeholder="인증코드 입력" v-model="params.authCode" @input="numberOnly(params.authCode, 'authCode')" maxlength="4" :disabled="isConfirmAuth">
                      <span class="time" v-show="!isConfirmAuth">{{ timer }}</span>
                    </label>
                    <button class="btn type_02" @click="confirmPhoneAuthCode" :disabled="isConfirmAuth">확인</button> <!--노란색 버튼은 type_02-->
                  </div>
                </div>
              </li>
              <li class="form__li m20" v-if="!noMoreInfo">
                <div class="form__ttl">담당자 부서</div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="text" :class="{'is-invalid': $v.params.contactDepartment.$error}" placeholder="담당자 부서를 입력해주세요." v-model.trim="params.contactDepartment">
                    </label>
                    <div class="hint on" v-show="$v.params.contactDepartment.$error">{{ valid.msg.contactDepartment }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li m20" v-if="!noMoreInfo">
                <div class="form__ttl">담당자 직통번호</div>
                <div class="form__in">
                  <div class="inline flex_hint">
                    <label class="input">
                      <input type="text" :class="{'is-invalid': $v.params.contactTel.$error}" placeholder="담당자 직통번호를 입력해주세요." v-model.trim="params.contactTel">
                    </label>
                    <div class="hint on" v-show="$v.params.contactTel.$error">{{ valid.msg.contactTel }}</div> <!-- on -->
                  </div>
                </div>
              </li>
              <li class="form__li m20">
                <div class="form__in  margin_n">
                  <div class="checkbox_line">
                    <label class="checkbox">
                      <input type="checkbox" name="terms" v-model="agree1">
                      <span class="label"><span>[필수] 서비스 이용약관</span></span>
                    </label>
                    <button class="checkbox_line__txt underline" @click="fnTerms('terms-modal', '서비스 이용약관')">내용보기</button>
                  </div>
                  <div class="checkbox_line">
                    <label class="checkbox">
                      <input type="checkbox" name="terms" v-model="agree2">
                      <span class="label"><span>[필수] 개인정보 처리방침</span></span>
                    </label>
                    <button class="checkbox_line__txt underline" @click="fnTerms('privacy-modal', '개인정보 처리방침')">내용보기</button>
                  </div>
<!--                  <div class="checkbox_line">-->
<!--                    <label class="checkbox">-->
<!--                      <input type="checkbox" name="terms" v-model="agree3">-->
<!--                      <span class="label"><span>[선택] 이벤트 소식 및 마케팅(광고) 정보 푸시 동의</span></span>-->
<!--                    </label>-->
<!--                  </div>-->
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="btn_wrap btn_wrap__fixed">
        <button class="btm" :class="{'on': isPossibleJoin}" @click="complete">회원가입</button> <!--활성화: on-->
      </div>
    </div>
  </main>
</template>
<script>

import {required} from 'vuelidate/lib/validators'
export default {
  data: function () {
    return {
      expired: false,
      timer: '5:00',
      sendPhoneAuthText: '인증',
      countDownInterval: null,
      isSendAuth: false,
      isConfirmAuth: false,
      valid: {
        msg: {
          required: '필수 항목 입니다.',
        }
      },
      agree1: false,
      agree2: false,
      agree3: false,
      agree3Description: '거부',
      params: {
        appVersion: '',
        deviceID: '',
        deviceTypeID: 0,
        registrationKey: '',
        userID: '',
        userPWD: '',
        userPWDConfirm: '',
        userType: 1,
        joinType: 10,
        joinPath: 11,
        companyName: '',
        companyNumber: '',
        companyAddress1: '',
        companyAddress2: '',
        companyTel: '',
        companyFax: '',
        contactName: '',
        contactDepartment: '',
        contactTel: '',
        contactPhone: '',
        contactEmail: '',
        isContact: '0',
        noMoreInfo: -1
      },
      noMoreInfo: false
    }
  },
  watch: {
    'params.companyOwnerPhone': function () {
      if (this.params.isContact === '1') {
        this.isConfirmAuth = false
        this.params.authCode = ''
        this.timer = '5:00'
        this.isSendAuth = false
      }
    },
    'params.contactPhone': function () {
      if (this.params.isContact === '2') {
        this.isConfirmAuth = false
        this.params.authCode = ''
        this.timer = '5:00'
        this.isSendAuth = false
      }
    },
    agree3(val) {
      this.params.isEvent = val ? 1 : -1
      this.agree3Description = val ? '동의' : '거부'
    }
  },
  validations: {
    params: {
      userID: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.userID = this.valid.msg.required
            return false
          }
          if(!this.$Util.isPasswordValid(val)) {
            this.valid.msg.userID = '영문자, 숫자 혼합 8~15자 이내로 입력해주세요.'
            return false
          }
          return true
        }
      },
      userPWD: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.userPWD = this.valid.msg.required
            return false
          }
          if(!this.$Util.isPasswordValid(val)) {
            this.valid.msg.userPWD = '영문자, 숫자 혼합 8~15자 이내로 입력해주세요.'
            return false
          }
          return true
        }
      },
      userPWDConfirm: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.userPWDConfirm = this.valid.msg.required
            return false
          }
          if (this.params.userPWD !== val) {
              this.valid.msg.userPWDConfirm = '위의 비밀번호와 동일하게 입력해주세요.'
              return false
          }
          return true
        }
      },
      companyName: {
        test: function (val) {
          if (!required(val)) {
            this.valid.msg.companyName = this.valid.msg.required
            return false
          }
          return true
        }
      },
      companyNumber: {
        test: function (val) {
          if (this.noMoreInfo) {
            return true
          }

          if (!required(val)) {
            this.valid.msg.companyNumber = this.valid.msg.required
            return false
          }
          return true
        }
      },
      companyTel: {
        test: function (val) {
          if (this.noMoreInfo) {
            return true
          }

          if (!required(val)) {
              this.valid.msg.companyTel = this.valid.msg.required
              return false
          }
          return true
        }
      },
      companyFax: {
        test: function (val) {
          return true
        }
      },
      companyOwner: {
        test: function (val) {
          if (this.noMoreInfo) {
            return true
          }

          if (!required(val)) {
            this.valid.msg.companyOwner = this.valid.msg.required
            return false
          }

          return true
        }
      },
      companyOwnerPhone: {
        test: function (val) {
          if (this.noMoreInfo) {
            return true
          }

          if (!required(val)) {
            this.valid.msg.companyOnwerPhone = this.valid.msg.required
            return false
          }
          return true
        }
      },
      companyOwnerEmail: {
        test: function (val) {
          if (this.noMoreInfo) {
            return true
          }

          if (!required(val)) {
            this.valid.msg.companyOwnerEmail = this.valid.msg.required
            return false
          }
          return true
        }
      },
      contactName: {
        test: function (val) {
          if (this.noMoreInfo) {
            return true
          }

          if (this.params.isContact === '2') {
            if (!required(val)) {
              this.valid.msg.contactName = this.valid.msg.required
              return false
            }
          }
          return true
        }
      },
      contactDepartment: {
        test: function (val) {
          return true
        }
      },
      contactEmail: {
        test: function (val) {
          if (this.noMoreInfo) {
            return true
          }

          if (this.params.isContact === '2') {
            if (!required(val)) {
              this.valid.msg.contactEmail = this.valid.msg.required
              return false
            }
          }
          return true
        }
      },
      contactPhone: {
        test: function (val) {
          if (this.noMoreInfo) {
            return true
          }

          if (this.params.isContact === '2') {
            if (!required(val)) {
              this.valid.msg.contactPhone = this.valid.msg.required
              return false
            }
          }
          return true
        }
      },
      contactTel: {
        test: function (val) {
          return true
        }
      },
      isContact: {
        test: function (val) {
          if (this.noMoreInfo) {
            return true
          }

          if (val === '0') {
            this.valid.msg.isContact = this.valid.msg.required
            return false
          }
          return true
        }
      },
    }
  },
  computed: {
    isPossibleJoin: function () {
      return true
      // if((this.params.userID != '' && !this.$v.params.userID.$error) &&
      //   (this.params.userPWD != '' && !this.$v.params.userPWD.$error) &&
      //   (this.params.userPWDConfirm != '' && !this.$v.params.userPWDConfirm.$error) &&
      //   (this.params.userName != '' && !this.$v.params.userName.$error) &&
      //   (this.params.userBirth != '' && !this.$v.params.userBirth.$error) &&
      //   (this.params.userAddress1 != '' && this.params.userAddress2 != '') &&
      //   this.isConfirmAuth &&
      //   (this.agree1 && this.agree2)) {
      //   return true
      // } else {
      //   return false
      // }
    }
  },
  created: function () {
    const deviceInfo = localStorage.deviceInfo === undefined ? {} : JSON.parse(localStorage.deviceInfo)
    if (!this.$Util.isEmpty(deviceInfo)) {
      this.params.appVersion = deviceInfo.appVersion
      this.params.deviceID = deviceInfo.deviceID
      this.params.deviceTypeID = deviceInfo.deviceTypeID
      this.params.registrationKey = deviceInfo.pushToken
    }
  },
  methods: {
    numberOnly: function (value, type) {
      switch (type) {
        case 'companyOwnerPhone':
          this.isConfirmAuth = false
          this.isSendAuth = false
          this.timer = '5:00'
          this.params.authCode = ''

          this.params.ccompanyOwnerPhone = this.$Util.maxLengthCheck(this.$Util.numberOnly2(value), 11)
          break
        case 'contactPhone':
          this.isConfirmAuth = false
          this.isSendAuth = false
          this.timer = '5:00'
          this.params.authCode = ''

          this.params.contactPhone = this.$Util.maxLengthCheck(this.$Util.numberOnly2(value), 11)
          break
        case 'authCode':
          this.params.authCode = this.$Util.maxLengthCheck(this.$Util.numberOnly2(value), 4)
          break
        case 'userBirth':
          this.params.userBirth = this.$Util.maxLengthCheck(this.$Util.numberOnly2(value), 8)
          break
      }
    },
    /**
     * 휴대폰 인증번호 확인
     */
    confirmPhoneAuthCode: function () {
      if (this.expired) {
        this.$Util.modalAlert({message: '인증시간이 만료되었습니다.<br>재 인증 해주세요.'})
        return false
      }

      if(this.params.authCode.length <= 0) {
        this.$Util.modalAlert({message: '인증코드를 입력해주세요.'})
        return false
      }

      let params = {
        userPhone: this.params.userPhone,
        authCode: this.params.authCode,
        authToken: this.params.authToken
      }

      this.$CommonSvc.confirmPhoneAuthCode(params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log(entity)
          if (code === 1) {
            this.$Util.modalAlert({message: '인증 되었습니다.'})
            this.isConfirmAuth = true
            clearInterval(this.countDownInterval)
          } else {
            this.$Util.modalAlert({message: message})
          }
        })
    },
    /**
     * 휴대폰 인증번호 발송
     */
    sendPhoneAuth: function () {
      if (this.params.isContact === '1') {
        if (this.params.companyOwnerPhone.length <= 0) {
          this.$Util.modalAlert({message: '대표자 휴대폰번호를 입력해주세요.'})
          return false
        }

        if (!this.$Util.isPhoneValid(this.params.companyOwnerPhone)) {
          this.$Util.modalAlert({message: '올바른 대표자 휴대폰번호를 입력해주세요.'})
          return false
        }
      } else {
        if (this.params.contactPhone.length <= 0) {
          this.$Util.modalAlert({message: '담당자 휴대폰번호를 입력해주세요.'})
          return false
        }

        if (!this.$Util.isPhoneValid(this.params.contactPhone)) {
          this.$Util.modalAlert({message: '올바른 담당자 휴대폰번호를 입력해주세요.'})
          return false
        }
      }

      let params = {
        authType: 1,
        contactPhone: this.params.isContact === '1' ? this.params.companyOwnerPhone : this.params.contactPhone
      }

      this.$CommonSvc.sendPhoneAuth(params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log('code: {%d}, message: {%s}, entity: %o', code, message, entity)
          if (code === 1) {
            // TODO 알럿 교체 (테스트용 코드 노출)
            // this.$Util.modalAlert({message: '인증코드가 발송 되었습니다. [' + entity['authCode(DEBUG)'] + ']'})
            this.$Util.modalAlert({message: '인증코드가 발송 되었습니다.'})
            this.params.authToken = entity.authToken
            this.params.authCode = ''
            this.isConfirmAuth = false
            this.isSendAuth = true
            this.sendPhoneAuthText = '재인증'
            this.expired = false
            this.timer = '5:00'
            this.countDown()
          } else {
            this.$Util.modalAlert({message: message})
          }
        })
    },
    countDown: function () {
      clearInterval(this.countDownInterval)
      let duration = this.$moment.duration({
        'minutes': '5',
        'seconds': '00'
      })
      const _this = this
      this.countDownInterval = setInterval(function () {
        duration = _this.$moment.duration(duration.asSeconds() - 1, 'seconds')
        let min = duration.minutes()
        let sec = duration.seconds()
        if (Number(sec) < 0) {
          _this.timer = '0:00'
          _this.expired = true
          clearInterval(_this.countDownInterval)
          return false
        }
        if (sec < 10) {
          sec = '0' + sec
        }

        _this.timer = min + ':' + sec
      }, 1000)
    },
    fnSearch: function () {
      const _this = this
      this.$store.commit('layout/setModal', {
        modalName: 'address-modal', data: {title: '주소 검색'}, callBack: function (item) {
          setTimeout(function () {
            _this.fnBindAddress(item)
          }, 200)
        }
      })
      // const _this = this
      // this.$ConstCode.openDaumPostcode(function (item) {
      //   _this.fnBindAddress(item)
      // })
    },
    fnBindAddress: function(item) {
      this.params.companyAddress1 = item.roadAddress
      // this.params.userAddress2 = item.roadAddress
    },
    fnTerms: function (modalName, modalTitle) {
      this.$store.commit('layout/setModal', {modalName: modalName, data: {title: modalTitle}})
    },
    complete: function () {
      this.$v.$touch()
      if (!this.$Util.isValid(this.$v, this.$el)) {
        return false
      }

      if (!this.noMoreInfo) {
        if (!this.isConfirmAuth) {
          this.$Util.modalAlert({message: '인증절차를 완료 해주세요.'})
          return false
        }

        if(this.params.companyAddress1.length <= 0 || this.params.companyAddress2.length <= 0) {
          this.$Util.modalAlert({message: '소재지 주소를 입력해주세요.'})
          return false
        }

        if(!this.agree1 || !this.agree2) {
          this.$Util.modalAlert({message: '필수 약관에 동의해주세요.'})
          return false
        }
      } else {
        this.params.companyName = ''
        this.params.companyNumber = ''
        this.params.companyAddress1 = ''
        this.params.companyAddress2 = ''
        this.params.companyTel = ''
        this.params.companyFax = ''
        this.params.companyOwner = ''
        this.params.companyOwnerPhone = ''
        this.params.companyOwnerEmail = ''
        this.params.contactName = ''
        this.params.contactDepartment = ''
        this.params.contactTel = ''
        this.params.contactPhone = ''
        this.params.contactEmail = ''
        this.params.noMoreInfo = 1
      }

      console.log(this.params)
      this.$AccountSvc.join(this.params)
        .then(res => {
          const code = res.code
          const message = res.message
          const entity = res.entity

          console.log('code: {%d}, message: {%s}, entity: %o', code, message, entity)
          if (code === 1) {
            const _this = this
            const data = {
              message: this.agree3Description
            }
            this.$Util.modalConfirm(this.$ConstCode.CONFIRM_TYPE.MARKETING, data, function () {
              setTimeout(function () {
                _this.$router.replace({
                  path: '/account/joinComplete',
                })
              }, 200)
            })
          } else {
            this.$Util.modalAlert({message: message})
          }
        })
    },
  }
}
</script>
<style scoped>
.required {
  color: red;
}

.nomore {
  color: #9e9e9e;
  display: flex;
  justify-content: right;
}
</style>

